const compactFormatter = new Intl.NumberFormat('ru-RU', { notation: 'compact', maximumFractionDigits: 1 })

/** 128400 → "128,4 тыс.". Возвращает null, если счётчик показывать не нужно. */
export const formatMembersCount = (count: number): string | null => {
  if (!count || count <= 0) return null
  return compactFormatter.format(count)
}
